import {
  AppMachineProvider,
  CacheProvider,
  FullscreenDismissBlocker,
  ServiceWorkerHandler,
} from "@indietabletop/appkit";
import "@indietabletop/appkit/globals.css.ts";
import { captureException } from "@sentry/react";
import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "react-hot-toast";
import { DatabaseProvider } from "../database.ts";
import { machine } from "../store.ts";
import { AppkitConfigProvider } from "./AppkitConfigProvider/AppConfigProvider.tsx";
import { ExceptionPage } from "./failures/ExceptionPage.tsx";
import { Routes } from "./Routes.tsx";
import { ScrollRestoration } from "./ScrollRestoration.tsx";

export function App() {
  return (
    <ErrorBoundary
      fallback={<ExceptionPage />}
      onError={(error) => captureException(error)}
    >
      <ScrollRestoration />
      <AppkitConfigProvider>
        <FullscreenDismissBlocker />

        <ServiceWorkerHandler path="/sw.js">
          <DatabaseProvider>
            <AppMachineProvider value={machine}>
              <CacheProvider>
                <Routes />
              </CacheProvider>
            </AppMachineProvider>
          </DatabaseProvider>
        </ServiceWorkerHandler>

        <Toaster position="bottom-right" />
      </AppkitConfigProvider>
    </ErrorBoundary>
  );
}
